import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { memberNewService } from '../services/memberNew.service';
import type { MemberFormData, RoleOption, TeamOption } from '../types/memberNew.types';

export function useMemberNew() {
  const [roles, setRoles] = useState<RoleOption[]>([]);
  const [teams, setTeams] = useState<TeamOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    async function loadOptions() {
      try {
        setIsLoading(true);
        const [rolesData, teamsData] = await Promise.all([
          memberNewService.getRoles(),
          memberNewService.getTeams()
        ]);
        setRoles(rolesData);
        setTeams(teamsData);
      } catch (error: any) {
        toast.error('Không thể tải danh sách tùy chọn');
      } finally {
        setIsLoading(false);
      }
    }
    loadOptions();
  }, []);

  const createMember = async (data: MemberFormData) => {
    try {
      setIsSubmitting(true);
      await memberNewService.createMember(data);
      toast.success('Thành viên đã được thêm thành công');
      return true;
    } catch (error: any) {
      toast.error(error.message || 'Lỗi khi thêm thành viên');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { roles, teams, isLoading, isSubmitting, createMember };
}
